import pickBy from "lodash/pickBy";
import { PriceMode } from "./PriceModeSelector";
import type { PriceValue } from "../../../misc/price";

export type PriceListPriceValue = Exclude<PriceValue, "INVALID">;

export interface OptionPrices {
  readonly selling: Record<string, PriceListPriceValue>;
  readonly purchase: Record<string, PriceListPriceValue>;
  readonly fit: Record<string, PriceListPriceValue>;
}

function updateDaysValue(
  days: string[],
  value: PriceListPriceValue | null | undefined,
  prices: Record<string, PriceListPriceValue>,
): Record<string, PriceListPriceValue> {
  if (value === null || value === undefined) {
    return pickBy(prices, (_, k) => !days.includes(k));
  }
  const changes = days.reduce((prev, curr) => ({ ...prev, [curr]: value }), {});
  return { ...prices, ...changes };
}

export function updateOptionPrices(
  optionPrices: OptionPrices,
  priceMode: PriceMode,
  days: string[],
  value: PriceListPriceValue | null | undefined,
): OptionPrices {
  switch (priceMode) {
    case PriceMode.PURCHASE_PRICE:
      return {
        ...optionPrices,
        purchase: updateDaysValue(days, value, optionPrices.purchase),
      };
    case PriceMode.SELLING_PRICE:
      return {
        ...optionPrices,
        selling: updateDaysValue(days, value, optionPrices.selling),
      };
    case PriceMode.FIT_PRICE:
      return {
        ...optionPrices,
        fit: updateDaysValue(days, value, optionPrices.fit),
      };
  }
}
